(function() {
    var m = angular.module('utils');

    m.directive('day', [function() {
        return {
            require: 'ngModel',
            priority: 1,
            link: function(scope, elm, attrs, ngModel) {

                var e = $(elm);
                var cMonth = 1;
                var cYear = 1;
                var cDays = 31;
                var daysInMonth = [
                    31, 28, 31,
                    30, 31, 30,
                    31, 31, 30,
                    31, 30, 31
                ];

                var firstDone = false;

                function removeTill28() {
                    $(elm).find('option[value="29"]').remove();
                    $(elm).find('option[value="30"]').remove();
                    $(elm).find('option[value="31"]').remove();
                }

                function fillDays(count) {
                    if (!firstDone) {
                        firstDone = true;
                        e.html('');
                        for (var i = 1; i <= count; i++) {
                            e.append($('<option>').val(i).html(i));
                        }
                    } else {
                        removeTill28();
                        for (var i = 0; i < cDays - 28; i++) {
                            e.append($('<option>').val(28 + i + 1).html(28 + i + 1));
                        }
                        if(ngModel.$modelValue > cDays) {
                            ngModel.$setViewValue(cDays);
                            e.val(cDays);
                        }

                    }
                }

                function setDay(days) {
                    fillDays(days);
                    e.val(ngModel.$viewValue);
                }

                function adjustValues() {
                    cDays = daysInMonth[cMonth - 1];
                    if (cYear % 4 == 0 && cMonth == 2) {
                        cDays = 29;
                    }
                }

                scope.$watch(function() {
                    return ngModel;
                }, function() {
                    setDay(cDays);
                });

                if (attrs.dayMonthSource) {
                    scope.$watch(attrs.dayMonthSource, function(month) {
                        if (month && month << 0 > 0 && month << 0 <= 12) {
                            cMonth = month;
                            adjustValues();
                            setDay(cDays);
                        }
                    });
                }

                if (attrs.dayYearSource) {
                    scope.$watch(attrs.dayYearSource, function(year) {
                        if (year) {
                            cYear = year;
                            adjustValues();
                            setDay(cDays);
                        }
                    });
                }
            }
        };
    }]);
})();
